<template>
  <el-dialog
    :visible.sync="dialogShow"
    class="small-dialog"
    title="设备类型配置"
    :close-on-click-modal="false"
    v-dialogDrag
  >
    <div>
      <el-form :model="configRuleForm" ref="ruleForm" label-width="150px" size="small">
        <el-form-item label="基础图标" prop="name">
          <div>
            <img-upload
              :uploadWidth="40"
              :uploadHeight="40"
              accept="jpg,jpeg,png,JPG,JPEG,gif"
              :isShowDeleteButton="false"
              @tips="tips"
              @update:fileId="basicUploadDone"
            ></img-upload>
          </div>
          <div class="flex">
            <img-upload
              v-for="item in basicList"
              :key="item.fileId"
              :uploadWidth="50"
              :uploadHeight="50"
              :isShowDeleteButton="true"
              :isShowUpdate="true"
              :fileId="item.fileId"
              class="ml-4px rounded"
              @tips="tips"
              @update:fileId="basicReuploadDone"
              @delete="deleteBasic"
              @reUpload="handleBasicReupload"
            ></img-upload>
          </div>
        </el-form-item>
        <el-form-item label="效果图标" prop="code">
          <div>
            <img-upload
              :uploadWidth="40"
              :uploadHeight="40"
              accept="jpg,jpeg,png,JPG,JPEG,gif"
              :isShowDeleteButton="true"
              :isShowUpdate="true"
              @tips="tips"
              @update:fileId="effectUploadDone"
            ></img-upload>
          </div>
          <div class="flex">
            <img-upload
              v-for="item in effectList"
              :key="item.fileId"
              :uploadWidth="50"
              :uploadHeight="50"
              :isShowDeleteButton="true"
              :isShowUpdate="true"
              :fileId="item.fileId"
              class="ml-4px rounded"
              @tips="tips"
              @update:fileId="effectReuploadDone"
              @delete="deleteEffect"
              @reUpload="handleEffectcReupload"
            ></img-upload>
          </div>
        </el-form-item>
        <el-form-item label="配置功能" prop="pointIcon">
          <el-checkbox-group v-model="configRuleForm.configItem">
            <el-checkbox label="定位视角"></el-checkbox>
            <el-checkbox label="有效范围"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <div class="flex justify-center items-center">
        <el-button
          type="primary"
          size="small"
          class="mr-10px"
          @click="saveConfig"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button type="default" size="small" @click="dialogShow = false">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Tag3DPositionImgApi, Tag3DPositionTagTypeApi } from '@wiz-api/tag-3d-position-management'
import ImgUpload from './ImgUpload'

const tag3DPositionImgApi = new Tag3DPositionImgApi()
const tag3DPositionTagTypeApi = new Tag3DPositionTagTypeApi()

export default {
  props: {
    show: Boolean,
    // 基础图标
    basicIconList: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 效果图标
    effectIconList: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 设备类型编码
    deviceTypeCode: {
      type: String,
      default: '',
    },
    // 设备类型的具体信息
    deviceTypeInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 基础图标id
    basicImgType: {
      type: String,
      default: '',
    },
    // 效果图标id
    effectImgType: {
      type: String,
      default: '',
    },
  },
  components: {
    ImgUpload,
  },
  data() {
    return {
      basicList: [], // 从props中复制一份基础图标数据，便于操作
      effectList: [], // 从props中复制一份效果图标数据
      addIconList: [], // 存放新上传的图标
      editIconList: [], // 存放编辑上传的图标
      delIconList: [], // 存放删除的图标id
      configRuleForm: {
        configItem: [],
      },
      editBasicIconId: '', // 基础图标重新上传的图标id
      editEfecctIconId: '', // 效果图标重新上传的图标id
      saveLoading: false,
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  mounted() {
    this.basicList = _.cloneDeep(this.basicIconList)
    this.effectList = _.cloneDeep(this.effectIconList)
    this.configRuleForm.configItem = []
    if (this.deviceTypeInfo.showAngleView) {
      this.configRuleForm.configItem.push('定位视角')
    }
    if (this.deviceTypeInfo.showMonitorRange) {
      this.configRuleForm.configItem.push('有效范围')
    }
  },
  methods: {
    // 基础图标新增，上传成功后返回的数据
    async basicUploadDone(item) {
      const iconInfo = {
        fileName: item.fileName,
        originalFileName: item.fileName,
        fileId: item.id,
        imgType: this.basicImgType,
        tagTypeCode: this.deviceTypeCode,
        threeDServerFilePath: `data://../apps/gat/img/${item.fileName}`,
      }
      this.basicList.push(iconInfo) // 添加到页面上显示
      this.addIconList.push(iconInfo) // 存储，供保存的时用
    },
    // 基础图标重新上传
    handleBasicReupload(fileId) {
      const findIcon = _.find(this.basicList, { fileId })
      this.editBasicIconId = findIcon.id
    },
    // 效果图标重新上传
    handleEffectcReupload(fileId) {
      const findIcon = _.find(this.effectList, { fileId })
      this.editEfecctIconId = findIcon.id
    },
    // 基础图标的编辑
    basicReuploadDone(item) {
      const iconInfo = {
        fileId: item.id,
        originalFileName: item.fileName,
        imgType: this.basicImgType,
        tagTypeCode: this.deviceTypeCode,
        threeDServerFilePath: `data://../apps/gat/img/${item.fileName}`,
      }
      const findIconIndex = _.findIndex(this.basicList, { id: this.editBasicIconId })
      if (findIconIndex !== -1) {
        const list = _.cloneDeep(this.basicList)
        iconInfo.id = list[findIconIndex].id // 编辑时，图片的id是不变的，只有fileId会变化
        list[findIconIndex] = iconInfo
        this.basicList = _.cloneDeep(list) // 替换到页面上显示
        this.editIconList.push(iconInfo) // 存储，供保存的时用
      }
    },
    // 效果图标新增
    effectUploadDone(item) {
      const iconInfo = {
        fileName: item.fileName,
        originalFileName: item.fileName,
        fileId: item.id,
        imgType: this.effectImgType,
        tagTypeCode: this.deviceTypeCode,
        threeDServerFilePath: `data://../apps/gat/img/${item.fileName}`,
      }
      this.effectList.push(iconInfo) // 添加到页面上显示
      this.addIconList.push(iconInfo) // 存储，供保存的时用
    },
    // 效果图标编辑
    effectReuploadDone(item) {
      const iconInfo = {
        fileId: item.id,
        originalFileName: item.fileName,
        imgType: this.effectImgType,
        tagTypeCode: this.deviceTypeCode,
        threeDServerFilePath: `data://../apps/gat/img/${item.fileName}`,
      }
      const findIconIndex = _.findIndex(this.effectList, { id: this.editEfecctIconId })
      if (findIconIndex !== -1) {
        const list = _.cloneDeep(this.effectList)
        iconInfo.id = list[findIconIndex].id
        list[findIconIndex] = iconInfo
        this.effectList = _.cloneDeep(list) // 替换到页面上显示
        this.editIconList.push(iconInfo) // 存储，供保存的时用
      }
    },
    // 删除基础图标
    deleteBasic(fileId) {
      const findIconIndex = _.findIndex(this.basicList, { fileId })
      if (findIconIndex !== -1) {
        this.delIconList.push(this.basicList[findIconIndex].id)
        this.basicList.splice(findIconIndex, 1)
      }
    },
    // 删除效果图标
    deleteEffect(fileId) {
      const findIconIndex = _.findIndex(this.effectList, { fileId })
      if (findIconIndex !== -1) {
        this.delIconList.push(this.effectList[findIconIndex].id)
        this.effectList.splice(findIconIndex, 1)
      }
    },
    tips() {},
    // 下载图标到三维服务器
    serverDownloadIcon() {
      // 新增图标的下载
      if (Array.isArray(this.addIconList)) {
        this.addIconList.forEach((ele) => {
          this.downloadImgFn(ele.fileId, ele.fileName)
        })
      }
      // 编辑图标的下载
      if (Array.isArray(this.editIconList)) {
        this.editIconList.forEach((ele) => {
          this.downloadImgFn(ele.fileId, ele.fileName)
        })
      }
    },
    // 具体的下载操作
    async downloadImgFn(fileId, fileName) {
      const fileServer = Wiz.GetModuleServer('file-management')
      const downloadUrl = `${fileServer}/api/file-management/files/public/${fileId}/download`
      // 本地上传成功后的图标下载到云渲染服务器
      this.player &&
        (await this.player.Native.File.downloadFile(
          `data://../apps/gat/img/${fileName}`,
          'GET',
          downloadUrl,
          {}
        ))
    },
    // 图标的新增、编辑、删除
    async handleIconCrud() {
      // 新增图标
      if (Array.isArray(this.addIconList) && this.addIconList.length > 0) {
        const res = await tag3DPositionImgApi.insertMany({
          body: this.addIconList,
        })
        if (res[1]) {
          // console.log('批量新增图标成功')
        }
      }

      // 编辑图标
      if (Array.isArray(this.editIconList) && this.editIconList.length > 0) {
        // const res2 = await tag3DPositionImgApi.updateMany({
        //   body: this.editIconList,
        // })
        this.editIconList.forEach(async (editIcon) => {
          const res2 = await tag3DPositionImgApi.update(editIcon.id, {
            body: editIcon,
          })
          if (res2[1]) {
            // console.log('单独编辑图标成功')
          }
        })
      }

      // 删除图标
      if (Array.isArray(this.delIconList) && this.delIconList.length > 0) {
        const params = {
          ids: this.delIconList,
        }
        const res3 = await tag3DPositionImgApi.deleteMany(params)
        if (res3[1]) {
          // console.log('批量删除图标成功')
        }
      }
    },
    // 保存定位视觉、有效范围的配置
    async handleConfig() {
      let cloneDeviceTypeInfo = _.cloneDeep(this.deviceTypeInfo)
      cloneDeviceTypeInfo = {
        ...cloneDeviceTypeInfo,
        showAngleView: this.configRuleForm.configItem.includes('定位视角'),
        showMonitorRange: this.configRuleForm.configItem.includes('有效范围'),
      }
      const [err] = await tag3DPositionTagTypeApi.update(cloneDeviceTypeInfo.id, {
        body: cloneDeviceTypeInfo,
      })
      if (!err) {
        this.$message.success('保存成功!')
      }
    },
    // 保存配置
    async saveConfig() {
      /* 基础、效果图标的新增、编辑、删除列表分别处理 */
      // 云渲染服务器下载上传的图标到服务器
      this.serverDownloadIcon()

      // 调用接口处理新增、编辑、删除的图标
      await this.handleIconCrud()

      // 保存定位视觉、有效范围的配置
      await this.handleConfig()
      this.dialogShow = false
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped></style>
